import _ from 'lodash';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createBrowserHistory } from 'history'
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunkMiddleware from 'redux-thunk';
import { reducer as form } from 'redux-form';
import { reducer as status } from '../Actions/status';
import { reducer as token } from '../Actions/token';
import { reducer as user } from '../Actions/user';

export default (reducers = {}) => {

  const history = createBrowserHistory();

  const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['token']
  };

  const middleware = applyMiddleware(
    routerMiddleware(history),
    thunkMiddleware
  );

  const reducerMap = _.assign({}, {
    form,
    status,
    token,
    user,
    ...reducers
  }, reducers);

  const reducer = combineReducers(reducerMap);

  const reducerWithRouter = connectRouter(history)(reducer);

  const persistedReducer = persistReducer(persistConfig, reducerWithRouter);

  const createStoreWidthDevTools = composeWithDevTools(middleware)(createStore);

  const store = createStoreWidthDevTools(persistedReducer);
  
  const persistor = persistStore(store)

  return { history, store, persistor };
}
